<div class="login-content" [class.loading]="isLoading">
  <a href="/" class="login-logo">
    <img src="./assets/img/logo.png" alt="Logo" />
  </a>

  <div class="login-form-wrapper" [@leftRightSlider]="counter">
    <form class="login-form w-100" *ngIf="!isHidden" [formGroup]="loginForm">
      <h1 class="login-title mb-2">Login</h1>

      <div class="mb-3 pt-1">
        <span class="input-label">Username</span>

        <input
          id="email-input"
          type="text"
          class="input"
          formControlName="username"
          placeholder="Enter Username"
          [class.is-invalid]="
            loginForm.get('username')?.invalid &&
            loginForm.get('username')?.touched
          "
        />

        <div
          class="invalid-feedback text-left"
          *ngIf="
            loginForm.get('username')?.invalid &&
            loginForm.get('username')?.touched
          "
        >
          <span *ngIf="loginForm.get('username')?.errors?.required"
            >This field is required</span
          >
        </div>
      </div>

      <div>
        <span class="input-label">Password</span>
        <input
          id="password-input"
          password-toggle
          type="password"
          class="input"
          placeholder="Enter Password"
          formControlName="password"
          [class.is-invalid]="
            loginForm.get('password')?.invalid &&
            loginForm.get('password')?.touched
          "
        />

        <div
          class="invalid-feedback d-block text-left"
          *ngIf="
            loginForm.get('password')?.invalid &&
            loginForm.get('password')?.touched
          "
        >
          <span *ngIf="loginForm.get('password')?.errors?.required"
            >This field is required</span
          >
          <span
            *ngIf="
              loginForm.get('password')?.errors?.minlength &&
              loginForm.get('password')?.errors?.minlength['requiredLength']
            "
          >
            Minimum length must be at least
            {{ loginForm.get('password')?.errors?.minlength['requiredLength'] }}
            characters
          </span>
        </div>

        <div class="invalid-feedback d-block text-left" *ngIf="errorMessage">
          <h6 class="font-weight-bold">{{ errorMessage }}</h6>
        </div>
      </div>

      <div class="mt-3 pt-2">
        <button
          id="login-button"
          type="submit"
          class="button blue w-100"
          [disabled]="!loginForm.valid"
          (click)="onSubmit()"
        >
          Log In
        </button>
        <div class="mt-3 d-flex justify-content-between">
          <a
            href="javascript:void(0)"
            (click)="onNext()"
            class="login-link text-decoration-none ml-auto"
            >Forgot password?</a
          >
        </div>
      </div>
    </form>

    <div class="login-form w-100" *ngIf="isHidden">
      <a
        href="javascript:void(0)"
        (click)="onPrevious()"
        class="back-link mb-3"
      >
        <i class="fas fa-angle-left mr-2"></i>
        <span>Back</span>
      </a>
      <password-reset-from
        (submitEmitter)="setLoading($event)"
      ></password-reset-from>
    </div>
  </div>
</div>
